// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-SX2h9";
var _4 = "controls__wrapper-1iyMz";
var _5 = "leg-2dseS";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "controls__wrapper", _5 as "leg" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "controls__wrapper": _4, "leg": _5 }
